import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../WizeAssist_white_logo.png';
import '../styles/Navbar.css';

function NavigationBar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container">
        <NavLink className="navbar-brand" to="/">
          <img
            src={Logo}
            alt="WizeAssist Logo"
            height="40"
            className="d-inline-block align-top"
          />
        </NavLink>
        
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={toggleMenu}
          aria-controls="navbarNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div 
          className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} 
          id="navbarNav"
        >
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <NavLink className="nav-link" to="/" end onClick={toggleMenu}>Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/about-us" onClick={toggleMenu}>About Us</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/solutions" onClick={toggleMenu}>Solutions</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/marketplace" onClick={toggleMenu}>Marketplace</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/blog" onClick={toggleMenu}>Blog</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/pricing" onClick={toggleMenu}>Pricing</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/contact" onClick={toggleMenu}>Contact</NavLink>
            </li>
            <li className="nav-item">
              <a 
                className="nav-link" 
                href="https://frontend-899566549579.europe-west1.run.app/login"
                target="_blank"
                rel="noopener noreferrer"
                onClick={toggleMenu}
              >
                Login
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default NavigationBar;
